import { Component } from '@angular/core';

import { PcBasedSimulatorComponent } from '../../../common/pc-based-simulator/pc-based-simulator.component';
import { SimulatorConfig } from '../../../core/models/simulation.model';
import { SimulatorType } from '../../../core/enums/simulator-type.enum';

@Component({
  selector: 'app-relative-permeability',
  imports: [PcBasedSimulatorComponent],
  templateUrl: './relative-permeability.component.html',
  styleUrl: './relative-permeability.component.scss',
  standalone: true,
})
export class RelativePermeabilityComponent {
  readonly config: SimulatorConfig = {
    title: ' Subsample - Relative Permeability Simulation',
    simulatorType: SimulatorType.SubsampleKr,
  };
}
